import React, {Component, Fragment, h} from "preact";
import {FormField, validateString} from "../../_common/forms/components/components";
import {Answer, Question} from "../../_api";
import {C, FR} from "../../_common/layout";
import {t} from "../../_i18n";
import {Field} from 'react-final-form';
import {showErrorClosed} from "../validateOfferEdit";
export class OpenQuestionEditor extends Component<any, any>{

    changeQuestion(question: Question, text: string){
        question.text = text;
        this.props.onChange();
    }


    render({questions, addQuestion, deleteQuestion, disabled}:any){

        return <div className="p-bottom m-bottom">
            {questions.map((question:any)=><Fragment key={question.id}>
                <FR className="">
                    <div className="sm-col-90 col-80">
                        <Field
                            name={"Pregunta"+question.id.toString()}
                            validate={() => validateString(question.text)}
                        >
                            {({input, meta}) =>
                                <Fragment>
                                    <input
                                        type="text"
                                        value={question.text}
                                        className={`form-control ${showErrorClosed(meta) && 'error'}`}
                                        onChange={(e:any)=>this.changeQuestion(question, e.target.value)}
                                        disabled={disabled}
                                    />
                                    {(showErrorClosed(meta)) && <div className='font-18 font-color-red'>{t('Debe escribir una pregunta')}</div>}
                                </Fragment>

                            }
                        </Field>
                        {/*<FormField validate={validateString} name={"Pregunta"+question.id.toString()} specificError="Debe escribir una pregunta" required onChange={(e:any)=>this.changeQuestion(question, e)}/>*/}
                    </div>
                    <div className="sm-col-10 col-20 d-flex flex-center-x">
                        {!disabled && <a className="font-26 cursor-pointer p-top" onClick={()=>deleteQuestion(question)}><i className="fal fa-times font-color-soft-gray" /></a>}
                    </div>
                </FR>
            </Fragment>)}
            {!disabled && <div className="cursor-pointer m-top text-primary font-18" onClick={addQuestion}>+ <span className='t-underline'>{t('Añadir pregunta abierta')}</span></div>}
        </div>
    }
}
